import React from 'react';
import widgetIcon from '/images/widget-icon.webp'

interface StepAgentClosedProps {
  setStep: (step: number) => void;
}

const StepAgentClosed: React.FC<StepAgentClosedProps> = ({ setStep }) => {
  return (
    <div className="absolute right-[46px] bottom-[46px] flex flex-col gap-[10px] items-end [@media(max-width:440px)]:right-[10px] [@media(max-width:440px)]:bottom-[10px] [@media(max-width:440px)]:w-[calc(100%-20px)]">
      <div className="gradient-wrap w-[58px] h-[57px] bg-white rounded-[50%] p-[2.5px]">
        <a onClick={() => setStep(1)} className="content cursor-pointer flex items-center justify-center">
          <img src={widgetIcon} alt="widget-icon" className="w-[30px] h-[29px]"/>
        </a>
      </div>
    </div>
  );
};

export default StepAgentClosed; 